// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__24n8G","row":"ProcedureTreatmentSummary_row__3wtJb"};